<template>
    <MainContent title="Crear categoría">
        <template v-slot:header>
            <h3 class="card-title">Crear Categoría</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormCategoria :categoria="categoria" @terminado="crearCategoria"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormCategoria from '@/components/backend/bases/categorias/FormCategoria';

    export default {    
        data() {
            return {
                categoria: {},
                loading: false,
                conf: {}
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearCategoria();
                }
            },
            crearCategoria() {
                this.loading = true;

                this.categoria.filters = {};
                this.categoria.lista_abonados_id = this.lista_id;
                this.categoria.lista_id = this.lista_id;

                if (this.categoria.representante) {
                    this.categoria.representante_id = this.categoria.representante.id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.crear'), this.categoria).then(res => {
                    this.$toast.success(res.data.message, {
                        message: 'Categoria creada correctamente'
                    });
                    this.$router.push({ name: 'back.bases.categorias.index', params: { lista_id: this.lista_id } });
                }).catch(error => {
                    if (error.response.data.errors) {
                        if (error.response.data.errors.name) {
                            this.$toast.error(error.response.data.errors.name.toString(), {});
                        } else {
                            this.$toast.error(error.response.data.errors.precio.toString(), {});
                        }
                    } else {
                        this.$toast.error(error.response.data.message, {});
                    }
                }).finally(() => this.loading = false);
            }
        },
        components: {
            MainContent, FormCategoria
        }
    }
</script>
